<template>
    <footer class="bg-teal-800 text-white">
        <div class="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div class="grid grid-cols-1 md:grid-cols-4 gap-12">
                <!-- Company Info -->
                <div class="col-span-1 md:col-span-2">
                    <img src="/images/logo-seeo2-white.svg" alt="SeeO2 Logo" class="h-24 mb-8">
                    <p class="text-white mb-4">Transformăm sustenabilitatea într-un avantaj competitiv pentru afacerea ta.</p>
                    <div class="flex space-x-4">
                        <a href="https://www.linkedin.com/company/seeo2/" target="_blank" rel="noopener noreferrer" class="text-white hover:text-teal-100 transition-colors">
                            <span class="sr-only">LinkedIn</span>
                            <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                            </svg>
                        </a>
                        <a href="https://www.facebook.com/seeo2app" target="_blank" rel="noopener noreferrer" class="text-white hover:text-teal-100 transition-colors">
                            <span class="sr-only">Facebook</span>
                            <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/>
                            </svg>
                        </a>
                    </div>
                </div>

                <!-- Quick Links -->
                <div>
                    <h3 class="text-lg font-semibold mb-4 text-white">Link-uri Rapide</h3>
                    <ul class="space-y-2">
                        <li><a href="/esg" class="text-white hover:text-teal-100 transition-colors">ESG</a></li>
                        <li><a href="/csrd" class="text-white hover:text-teal-100 transition-colors">CSRD</a></li>
                        <li><a href="#" class="text-white hover:text-teal-100 transition-colors">Blog</a></li>
                    </ul>
                </div>

                <!-- Contact Info -->
                <div>
                    <h3 class="text-lg font-semibold mb-4 text-white">Contact</h3>
                    <ul class="space-y-2 text-white">
                        <li class="flex items-center">
                            <svg class="h-5 w-5 mr-2 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                            </svg>
                            hello@seeo2.app
                        </li>
                        <li class="flex items-center">
                            <svg class="h-5 w-5 mr-2 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                            </svg>
                            +40 744 340 390
                        </li>
                        <li class="flex items-center">
                            <svg class="h-5 w-5 mr-2 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                            </svg>
                            {{ address }}
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Bottom Bar -->
            <div class="border-t border-teal-700 mt-12 pt-8">
                <div class="flex flex-col md:flex-row justify-between items-center">
                    <p class="text-white text-sm">SeeO2. Toate drepturile rezervate.</p>
                    <div class="flex space-x-6 mt-4 md:mt-0">
                        <a href="/privacy" class="text-white hover:text-teal-100 transition-colors text-sm">Politica de Confidențialitate</a>
                        <a href="/terms" class="text-white hover:text-teal-100 transition-colors text-sm">Termeni și Condiții</a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
import { usePage } from "@inertiajs/vue3";

const page = usePage();
const locale = page.props.locale || 'ro';
const address = locale === 'en' ? 'Sevastopol 24, Sector 1, Bucharest' : 'Sevastopol 24, Sector 1, București';
</script>
